import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function FaqPage() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(null);

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') },
    { q: t('faq.q5'), a: t('faq.a5') },
    { q: t('faq.q6'), a: t('faq.a6') },
    { q: 'How does CSSBuy shipping work?', a: 'CSSBuy offers multiple international shipping carriers. After items arrive at the warehouse and pass QC, you select a shipping method, pay the shipping fee, and CSSBuy dispatches your package. Costs depend on weight, volume, destination, and chosen method.' },
    { q: 'What is QC in CSSBuy?', a: 'QC stands for Quality Control. When items arrive at the CSSBuy warehouse, they can take photos showing the actual condition, appearance, and details of your products. You review these photos before approving shipment to your address.' },
    { q: 'Can I return items on CSSBuy?', a: 'Returns depend on the seller\'s policy and the item condition. If QC photos reveal issues, you can often request a return or exchange before the item leaves the warehouse. After international shipping, returns become more complex.' },
    { q: 'How long does CSSBuy shipping take?', a: 'Shipping times vary by method and destination. Express services typically take 3-10 days, standard air mail 10-25 days, and economy or sea freight can take 30-60 days. Customs processing in your country may add additional time.' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 md:pt-32 pb-16 md:pb-24">
        <div className="container-main">
          <div className="max-w-3xl mx-auto">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-500 transition-colors">{t('nav.home')}</a>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-700">{t('faq.title')}</span>
            </nav>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 leading-tight mb-4">
              {t('faq.title')}
            </h1>
            <p className="text-sm text-foreground-600 mb-8">
              {t('faq.description')}
            </p>

            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                  <button
                    onClick={() => setOpen(open === i ? null : i)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</span>
                    <i className={`ri-${open === i ? 'subtract' : 'add'}-line text-foreground-500 shrink-0 text-lg`}></i>
                  </button>
                  {open === i && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-10 p-5 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{t('faq.stillQuestions')}</h3>
              <p className="text-sm text-foreground-600 mb-4">{t('faq.exploreMore')}</p>
              <div className="flex flex-wrap justify-center gap-3">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors">
                  {t('content.visitMain')}
                  <i className="ri-external-link-line"></i>
                </a>
                <a href="/contact/" className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-200 text-foreground-800 text-sm font-medium rounded-full hover:bg-background-100 transition-colors">
                  {t('faq.contactBtn')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}